import React from "react";
import { useTranslation } from "react-i18next";
import SlotText from "../../invitation/SlotText";

// The title and subtitle are the couple's lines when they wrote them
// (text slots `invitationTitle` / `invitationSubtitle`), else the template's,
// worded for the event type.
const VenueDetailMandateImage = ({
  mainImage,
  date,
  eventType = "wedding",
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <section className="section topless" {...rest}>
      <div className="container">
        <div className="im-frame">
          <img
            alt={t("venues.invitation.photoAlt", { context: eventType })}
            src={mainImage ?? "/assets/photos/agapae-hero.jpg"}
            className="large-im _90"
          />
        </div>
        <div className="p-wrap mandat">
          <div className="p-block mandat">
            <div className="pad-20">
              <SlotText slot="invitationTitle" as="h2" className="heading-50" />
            </div>
            <SlotText slot="invitationSubtitle" as="p" className="body-18" />
          </div>
          <div className="year-div mbm-exclusion">
            <h4 className="year-txt">{date}</h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenueDetailMandateImage;
